import React from 'react';
import { graphql, useStaticQuery } from "gatsby"
import { CMSSelfTestEntry } from './model/CMSSelfTestEntry';

type PageProps = {
    children?: any;
};

export type CMSData = {
    nav: {
        selfTests: {
            id: string,
            href: string,
            name: string,
        }[];
    }
};

const ctx = React.createContext<CMSData>({
    nav: {
        selfTests: [
            {
                "id": "adpkd",
                "name": "1 分鐘評估多囊腎病風險",
                "href": "https://www.finddoc.com/self-test/adpkd"
            },
            {
                "id": "cholesterol",
                "name": "1 分鐘評估膽固醇超標風險",
                "href": "https://www.finddoc.com/self-test/cholesterol"
            },
            {
                "id": "luts",
                "name": "1 分鐘評估常見泌尿疾病風險",
                "href": "https://www.finddoc.com/self-tests/luts-%E4%B8%8B%E6%B3%8C%E5%B0%BF%E9%81%93%E7%97%87%E7%8B%80"
            },
            {
                "id": "mitral-regurgitation",
                "name": "1 分鐘評估二尖瓣倒流風險",
                "href": "https://www.finddoc.com/self-tests/mitral-regurgitation-%E4%BA%8C%E5%B0%96%E7%93%A3%E5%80%92%E6%B5%81"
            },
            {
                "id": "sleep-apnea",
                "name": "1 分鐘評估睡眠窒息症風險",
                "href": "https://www.finddoc.com/self-tests/sleep-apnea-%E7%9D%A1%E7%9C%A0%E7%AA%92%E6%81%AF%E7%97%87"
            },
            {
                "id": "gerd",
                "name": "1 分鐘評估是否屬胃酸倒流",
                "href": "https://www.finddoc.com/self-tests/gerd-%E8%83%83%E9%85%B8%E5%80%92%E6%B5%81"
            },
            {
                "id": "eczema",
                "name": "1 分鐘評估濕疹病情控制程度",
                "href": "https://www.finddoc.com/self-tests/eczema-%E6%BF%95%E7%96%B9"
            },
            {
                "id": "bmi",
                "name": "BMI 計算機",
                "href": "https://www.finddoc.com/health/%e9%86%ab%e7%99%82%e5%88%86%e7%a7%91/"
            }
        ],
    }
});

export function CMSDataProvider({ children }: PageProps) {
    const { cmsData } = useStaticQuery(graphql`
        query {
            cmsData(name: { eq: "self-test-entries" }) {
                data
            }
        }
    `);

    const [cmsNavBarItems, setCmsNavBarItems] = React.useState<CMSSelfTestEntry[]>([]);

    const nav = React.useMemo(() => {
        return {
            selfTests: cmsNavBarItems.map(x => {
                return {
                    id: x.slug,
                    href: x.href,
                    name: x.title,
                }
            })
        }
    }, [cmsNavBarItems]);

    React.useEffect(() => {
        setCmsNavBarItems(JSON.parse(cmsData.data));
    }, [cmsData]);

    const value = {
        nav,
    }

    return (
        <ctx.Provider value={value}>
            {children}
        </ctx.Provider>
    );
}

export function useCMS(): CMSData {
    const context = React.useContext(ctx);

    if (!context)
        throw new Error(
            `useCMS must be used inside a 'CMSDataProvider'`,
        );

    return context;
}